import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

import { approvalFormSchema } from 'modules/workflows/components/Sidepanel/schemas/approvalFormSchema'

const createManualApproveHandlerSchema = () => {
  const baseSchema = z.object({
    due_on_value: z
      .number({
        message: i18n.t('workflows.sidepanel.approval.validation.due_date_required'),
      })
      .min(1, {
        message: i18n.t('workflows.sidepanel.approval.validation.due_date_min_value'),
      }),
    due_on_unit: z.enum(['hours', 'days', 'weeks', 'months'], {
      message: i18n.t('workflows.sidepanel.approval.validation.due_date_unit_required'),
    }),
  })

  const employeeSegmentSchema = z.union([
    z.object({
      name: z.enum(['anyone_in_team', 'team_leads'], {
        message: i18n.t('workflows.sidepanel.approval.validation.strategy_required'),
      }),
      input: z
        .object({
          team_id: z
            .number({
              message: i18n.t('workflows.sidepanel.approval.validation.team_required'),
            })
            .nullable(),
        })
        .refine(
          (data) => {
            return data.team_id && data.team_id > 0
          },
          {
            message: i18n.t('workflows.sidepanel.approval.validation.team_required'),
          }
        ),
    }),
    z.object({
      name: z.enum(['employee_manager', 'admins'], {
        message: i18n.t('workflows.sidepanel.approval.validation.strategy_required'),
      }),
      input: z.object({}),
    }),
  ])

  const payloadSchema = baseSchema
    .extend({
      reviewer_ids: z.array(z.number()).optional(),
      employee_segments: z.array(employeeSegmentSchema).optional(),
    })
    .refine(
      (data) => {
        const hasReviewers = data.reviewer_ids && data.reviewer_ids.length > 0
        const hasSegments = data.employee_segments && data.employee_segments.length > 0
        return hasReviewers || hasSegments
      },
      {
        message: i18n.t('workflows.sidepanel.approval.validation.reviewers_required'),
        path: ['reviewer_ids'],
      }
    )

  return approvalFormSchema.extend({
    nodeData: z.object({
      handlerType: z.literal('request_review'),
      payload: payloadSchema,
    }),
  })
}

export const manualApproveHandlerSchema = createManualApproveHandlerSchema()

export type ManualApproveHandlerSchema = z.infer<
  ReturnType<typeof createManualApproveHandlerSchema>
>
